import { render, staticRenderFns } from "./Topic2Empty.vue?vue&type=template&id=27c5d49f&scoped=true"
import script from "./Topic2Empty.vue?vue&type=script&lang=js"
export * from "./Topic2Empty.vue?vue&type=script&lang=js"
import style0 from "./Topic2Empty.vue?vue&type=style&index=0&id=27c5d49f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c5d49f",
  null
  
)

export default component.exports